(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[390],{

/***/ 1532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var components_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3;






var Hero = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  background: ", ";\n  color: ", ";\n  padding: 40px 10px;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.GREEN;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.WHITE;
});
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  max-width: ", ";\n  margin: auto;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.width.medium;
});
var Title = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(components_typography__WEBPACK_IMPORTED_MODULE_2__.H1)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  color: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.BEIGE;
});

var PageHero = function PageHero(_ref5) {
  var title = _ref5.title,
      text = _ref5.text;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Hero, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Content, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        children: text
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageHero);

/***/ }),

/***/ 84715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var components_PageHero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1532);
/* harmony import */ var components_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3;








var Section = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  max-width: ", ";\n  margin: auto;\n  padding: 10px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.width.medium;
});
var StyledP = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(components_typography__WEBPACK_IMPORTED_MODULE_3__.P)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 26px;\n"])));
var Li = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 26px;\n"])));

var OmOss = function OmOss() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_PageHero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      title: "Om oss",
      text: "Digito grundades i b\xF6rjan av 2021 med m\xE5ls\xE4ttningen en mer h\xE5llbar aff\xE4rsv\xE4rld f\xF6r papper visitkort. Vi lanserade v\xE5r f\xF6rsta tj\xE4nst i maj 2021 och mer kommer!"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(Section, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledP, {
        children: "Med Digito vill vi ge f\xF6retagare och andra kreat\xF6rer m\xF6jligheten att hantera och dela sina sociala kanaler under en samlad plattform. En plattform som varken intr\xE4nger p\xE5 milj\xF6n eller g\xE5r att sl\xE4nga i en papperskorg."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("ul", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Li, {
          children: "8-10 miljarder visitkort trycks \xE5rligen."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Li, {
          children: "88% av alla tryckta visitkort sl\xE4ngs i en papperskorg efter att de delats ut.\xA0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Li, {
          children: "8 miljoner tr\xE4d kan r\xE4ddas \xE5rligen."
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledP, {
        children: "Varf\xF6r inte imponera med ett modernt visitkort p\xE5 dina framtida m\xF6ten?"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledP, {
        children: "Omst\xE4llning till en h\xE5llbar konsumtion och produktion av varor \xE4r en n\xF6dv\xE4ndighet f\xF6r att minska v\xE5r negativa p\xE5verkan p\xE5 klimat och milj\xF6. D\xE4rf\xF6r lyder v\xE5rt motto \u2013 Vi \xE4r inte i m\xE5l f\xF6rr\xE4n visitkorten \xE4r i mobilen ist\xE4llet f\xF6r papperskorgen.\xA0"
      })]
    })]
  });
};

OmOss.layoutOptions = {
  backgroundColor: '#e9d3b8',
  footer: true,
  noBottomSpacing: true
};
/* harmony default export */ __webpack_exports__["default"] = (OmOss);

/***/ }),

/***/ 47343:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-oss",
      function () {
        return __webpack_require__(84715);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(47343); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);